import { createSlice } from '@reduxjs/toolkit';

type TagsSliceType = {
  tags: {
    items: Record<string, unknown>[];
    isLoading: boolean;
    isError: boolean;
  };
};

const initialState: TagsSliceType = {
  tags: {
    items: [],
    isLoading: false,
    isError: false,
  },
};

export const tagsSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
});

export const {} = tagsSlice.actions;
